 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];

 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		// chunk prefetching for javascript
 		prefetchChunks.forEach(function(chunkId) {
 			if(installedChunks[chunkId] === undefined) {
 				installedChunks[chunkId] = null;
 				var link = document.createElement('link');

 				if (__webpack_require__.nc) {
 					link.setAttribute("nonce", __webpack_require__.nc);
 				}
 				link.rel = "prefetch";
 				link.as = "script";
 				link.href = jsonpScriptSrc(chunkId);
 				document.head.appendChild(link);
 			}
 		});
 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		0: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + chunkId + ".build.js"
 	}

 	// object to store loaded and loading wasm modules
 	var installedWasmModules = {};

 	function promiseResolve() { return Promise.resolve(); }

 	var wasmImportObjects = {
 		123: function() {
 			return {
 				"./buttplug_rs_ffi_bg.js": {
 					"__wbindgen_object_drop_ref": function(p0i32) {
 						return installedModules[121].exports["Bb"](p0i32);
 					},
 					"__wbg_log_c4384c5721dc6261": function(p0i32,p1i32) {
 						return installedModules[121].exports["A"](p0i32,p1i32);
 					},
 					"__wbindgen_object_clone_ref": function(p0i32) {
 						return installedModules[121].exports["Ab"](p0i32);
 					},
 					"__wbindgen_string_new": function(p0i32,p1i32) {
 						return installedModules[121].exports["Db"](p0i32,p1i32);
 					},
 					"__wbindgen_cb_drop": function(p0i32) {
 						return installedModules[121].exports["pb"](p0i32);
 					},
 					"__wbg_new_59cb74e423758ede": function() {
 						return installedModules[121].exports["I"]();
 					},
 					"__wbg_stack_558ba5917b466edd": function(p0i32,p1i32) {
 						return installedModules[121].exports["gb"](p0i32,p1i32);
 					},
 					"__wbg_error_4bb6c2a97407129a": function(p0i32,p1i32) {
 						return installedModules[121].exports["o"](p0i32,p1i32);
 					},
 					"__wbg_log_75fc43480a5907a7": function(p0i32,p1i32) {
 						return installedModules[121].exports["y"](p0i32,p1i32);
 					},
 					"__wbg_log_a73f6bdd88fae982": function(p0i32,p1i32,p2i32,p3i32,p4i32,p5i32,p6i32,p7i32) {
 						return installedModules[121].exports["z"](p0i32,p1i32,p2i32,p3i32,p4i32,p5i32,p6i32,p7i32);
 					},
 					"__wbg_mark_e32edf3b52687c6a": function(p0i32,p1i32) {
 						return installedModules[121].exports["B"](p0i32,p1i32);
 					},
 					"__wbg_measure_0c2a5c5e55e16643": function(p0i32,p1i32,p2i32,p3i32) {
 						return installedModules[121].exports["C"](p0i32,p1i32,p2i32,p3i32);
 					},
 					"__wbg_Window_f826a1dec163bacb": function(p0i32) {
 						return installedModules[121].exports["a"](p0i32);
 					},
 					"__wbindgen_is_undefined": function(p0i32) {
 						return installedModules[121].exports["yb"](p0i32);
 					},
 					"__wbg_WorkerGlobalScope_967d186155183d38": function(p0i32) {
 						return installedModules[121].exports["b"](p0i32);
 					},
 					"__wbg_instanceof_Window_fbe0320f34c4cd31": function(p0i32) {
 						return installedModules[121].exports["w"](p0i32);
 					},
 					"__wbg_navigator_74ca2cbc2348b985": function(p0i32) {
 						return installedModules[121].exports["F"](p0i32);
 					},
 					"__wbg_clearTimeout_691ea78b4285bbea": function(p0i32,p1i32) {
 						return installedModules[121].exports["i"](p0i32,p1i32);
 					},
 					"__wbg_setTimeout_62ddbd1dbc58b759": function(p0i32,p1i32,p2i32) {
 						return installedModules[121].exports["X"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_getCharacteristic_65c13e59ceaf8c8d": function(p0i32,p1i32,p2i32) {
 						return installedModules[121].exports["q"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_value_9a00dc0aad5295ac": function(p0i32) {
 						return installedModules[121].exports["mb"](p0i32);
 					},
 					"__wbg_setoncharacteristicvaluechanged_a33b0f85ecea7368": function(p0i32,p1i32) {
 						return installedModules[121].exports["bb"](p0i32,p1i32);
 					},
 					"__wbg_readValue_31b4e10693561f30": function(p0i32) {
 						return installedModules[121].exports["Q"](p0i32);
 					},
 					"__wbg_startNotifications_d49842931c930a11": function(p0i32) {
 						return installedModules[121].exports["hb"](p0i32);
 					},
 					"__wbg_writeValue_034f0ba94268d234": function(p0i32,p1i32,p2i32) {
 						return installedModules[121].exports["ob"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_connect_5c2075a8c06276c5": function(p0i32) {
 						return installedModules[121].exports["l"](p0i32);
 					},
 					"__wbg_getPrimaryService_8cc1dc94912a3410": function(p0i32,p1i32,p2i32) {
 						return installedModules[121].exports["r"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_target_62e7aaed452a6541": function(p0i32) {
 						return installedModules[121].exports["jb"](p0i32);
 					},
 					"__wbg_requestDevice_cc9afae828c2ac9f": function(p0i32,p1i32) {
 						return installedModules[121].exports["R"](p0i32,p1i32);
 					},
 					"__wbg_id_d1000b241d09274f": function(p0i32,p1i32) {
 						return installedModules[121].exports["v"](p0i32,p1i32);
 					},
 					"__wbg_name_87829ccaae19dc7b": function(p0i32,p1i32) {
 						return installedModules[121].exports["E"](p0i32,p1i32);
 					},
 					"__wbg_gatt_c92ccfd7b968afb2": function(p0i32) {
 						return installedModules[121].exports["p"](p0i32);
 					},
 					"__wbg_setongattserverdisconnected_6c8d7074af07b193": function(p0i32,p1i32) {
 						return installedModules[121].exports["db"](p0i32,p1i32);
 					},
 					"__wbg_clearTimeout_e97232387865edcf": function(p0i32,p1i32) {
 						return installedModules[121].exports["j"](p0i32,p1i32);
 					},
 					"__wbg_setTimeout_e5c727d4159ae515": function(p0i32,p1i32,p2i32) {
 						return installedModules[121].exports["Y"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_bluetooth_a74a5601131dd641": function(p0i32) {
 						return installedModules[121].exports["c"](p0i32);
 					},
 					"__wbg_setonopen_48801d21f66dc5b2": function(p0i32,p1i32) {
 						return installedModules[121].exports["fb"](p0i32,p1i32);
 					},
 					"__wbg_setonerror_926b779f5ef98aec": function(p0i32,p1i32) {
 						return installedModules[121].exports["cb"](p0i32,p1i32);
 					},
 					"__wbg_setonmessage_73e6657a1d4e949a": function(p0i32,p1i32) {
 						return installedModules[121].exports["eb"](p0i32,p1i32);
 					},
 					"__wbg_new_d7419781a618ac1a": function(p0i32,p1i32) {
 						return installedModules[121].exports["J"](p0i32,p1i32);
 					},
 					"__wbg_close_bff451ff5feb5b9f": function(p0i32) {
 						return installedModules[121].exports["k"](p0i32);
 					},
 					"__wbg_send_7e7d1873965d2755": function(p0i32,p1i32,p2i32) {
 						return installedModules[121].exports["W"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_data_b59dd3983cd7c614": function(p0i32) {
 						return installedModules[121].exports["n"](p0i32);
 					},
 					"__wbg_call_ab183a630df3a257": function(p0i32,p1i32) {
 						return installedModules[121].exports["h"](p0i32,p1i32);
 					},
 					"__wbg_new_1abc33d4f9ba3e80": function() {
 						return installedModules[121].exports["G"]();
 					},
 					"__wbg_push_44968dcdf4cfbb43": function(p0i32,p1i32) {
 						return installedModules[121].exports["O"](p0i32,p1i32);
 					},
 					"__wbg_buffer_3ee252ffa7d82e3f": function(p0i32) {
 						return installedModules[121].exports["d"](p0i32);
 					},
 					"__wbg_byteLength_80b4452535587127": function(p0i32) {
 						return installedModules[121].exports["f"](p0i32);
 					},
 					"__wbg_newnoargs_ab5e899738c0eff4": function(p0i32,p1i32) {
 						return installedModules[121].exports["L"](p0i32,p1i32);
 					},
 					"__wbg_call_7a2b5e98ac536644": function(p0i32,p1i32,p2i32) {
 						return installedModules[121].exports["g"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_new_dc5b27cfd2149b8f": function() {
 						return installedModules[121].exports["K"]();
 					},
 					"__wbg_resolve_9b0f9ddf5f89cb1e": function(p0i32) {
 						return installedModules[121].exports["T"](p0i32);
 					},
 					"__wbg_then_b4358f6ec1ee6657": function(p0i32,p1i32) {
 						return installedModules[121].exports["lb"](p0i32,p1i32);
 					},
 					"__wbg_then_3d9a54b0affdf26d": function(p0i32,p1i32,p2i32) {
 						return installedModules[121].exports["kb"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_self_77eca7b42660e1bb": function() {
 						return installedModules[121].exports["U"]();
 					},
 					"__wbg_window_51dac01569f1ba70": function() {
 						return installedModules[121].exports["nb"]();
 					},
 					"__wbg_globalThis_34bac2d08ebb9b58": function() {
 						return installedModules[121].exports["t"]();
 					},
 					"__wbg_global_1c436164a66c9c22": function() {
 						return installedModules[121].exports["u"]();
 					},
 					"__wbg_buffer_bc64154385c04ac4": function(p0i32) {
 						return installedModules[121].exports["e"](p0i32);
 					},
 					"__wbg_newwithbyteoffsetandlength_3c8748473807c7cf": function(p0i32,p1i32,p2i32) {
 						return installedModules[121].exports["N"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_length_e9f6f145de2fede5": function(p0i32) {
 						return installedModules[121].exports["x"](p0i32);
 					},
 					"__wbg_new_22a33711cf65b661": function(p0i32) {
 						return installedModules[121].exports["H"](p0i32);
 					},
 					"__wbg_set_b29de3f25280c6ec": function(p0i32,p1i32,p2i32) {
 						return installedModules[121].exports["ab"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_newwithbyteoffset_1220284753489dde": function(p0i32,p1i32) {
 						return installedModules[121].exports["M"](p0i32,p1i32);
 					},
 					"__wbg_set_3afd31f38e771338": function(p0i32,p1i32,p2i32) {
 						return installedModules[121].exports["Z"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_getRandomValues_11115a852729f4e8": function(p0i32,p1i32,p2i32) {
 						return installedModules[121].exports["s"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_randomFillSync_a2d002fc3b8e30f7": function(p0i32,p1i32,p2i32) {
 						return installedModules[121].exports["P"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_self_a5f0fe5564782787": function() {
 						return installedModules[121].exports["V"]();
 					},
 					"__wbg_static_accessor_MODULE_7f278c5446c126c8": function() {
 						return installedModules[121].exports["ib"]();
 					},
 					"__wbg_require_29e58b5f6f133563": function(p0i32,p1i32,p2i32) {
 						return installedModules[121].exports["S"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_crypto_d91429ea1a087f70": function(p0i32) {
 						return installedModules[121].exports["m"](p0i32);
 					},
 					"__wbg_msCrypto_c8be2bb4fc7d8cd3": function(p0i32) {
 						return installedModules[121].exports["D"](p0i32);
 					},
 					"__wbindgen_is_string": function(p0i32) {
 						return installedModules[121].exports["xb"](p0i32);
 					},
 					"__wbindgen_string_get": function(p0i32,p1i32) {
 						return installedModules[121].exports["Cb"](p0i32,p1i32);
 					},
 					"__wbindgen_debug_string": function(p0i32,p1i32) {
 						return installedModules[121].exports["wb"](p0i32,p1i32);
 					},
 					"__wbindgen_throw": function(p0i32,p1i32) {
 						return installedModules[121].exports["Eb"](p0i32,p1i32);
 					},
 					"__wbindgen_memory": function() {
 						return installedModules[121].exports["zb"]();
 					},
 					"__wbindgen_closure_wrapper669": function(p0i32,p1i32,p2i32) {
 						return installedModules[121].exports["sb"](p0i32,p1i32,p2i32);
 					},
 					"__wbindgen_closure_wrapper671": function(p0i32,p1i32,p2i32) {
 						return installedModules[121].exports["tb"](p0i32,p1i32,p2i32);
 					},
 					"__wbindgen_closure_wrapper673": function(p0i32,p1i32,p2i32) {
 						return installedModules[121].exports["ub"](p0i32,p1i32,p2i32);
 					},
 					"__wbindgen_closure_wrapper675": function(p0i32,p1i32,p2i32) {
 						return installedModules[121].exports["vb"](p0i32,p1i32,p2i32);
 					},
 					"__wbindgen_closure_wrapper2449": function(p0i32,p1i32,p2i32) {
 						return installedModules[121].exports["qb"](p0i32,p1i32,p2i32);
 					},
 					"__wbindgen_closure_wrapper4092": function(p0i32,p1i32,p2i32) {
 						return installedModules[121].exports["rb"](p0i32,p1i32,p2i32);
 					}
 				}
 			};
 		},
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// Fetch + compile chunk loading for webassembly

 		var wasmModules = {"1":[123]}[chunkId] || [];

 		wasmModules.forEach(function(wasmModuleId) {
 			var installedWasmModuleData = installedWasmModules[wasmModuleId];

 			// a Promise means "currently loading" or "already loaded".
 			if(installedWasmModuleData)
 				promises.push(installedWasmModuleData);
 			else {
 				var importObject = wasmImportObjects[wasmModuleId]();
 				var req = fetch(__webpack_require__.p + "" + {"123":"8b4ec1dfc3ee2ffb9df7"}[wasmModuleId] + ".module.wasm");
 				var promise;
 				if(importObject instanceof Promise && typeof WebAssembly.compileStreaming === 'function') {
 					promise = Promise.all([WebAssembly.compileStreaming(req), importObject]).then(function(items) {
 						return WebAssembly.instantiate(items[0], items[1]);
 					});
 				} else if(typeof WebAssembly.instantiateStreaming === 'function') {
 					promise = WebAssembly.instantiateStreaming(req, importObject);
 				} else {
 					var bytesPromise = req.then(function(x) { return x.arrayBuffer(); });
 					promise = bytesPromise.then(function(bytes) {
 						return WebAssembly.instantiate(bytes, importObject);
 					});
 				}
 				promises.push(installedWasmModules[wasmModuleId] = promise.then(function(res) {
 					return __webpack_require__.w[wasmModuleId] = (res.instance || res).exports;
 				}));
 			}
 		});
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	// object with all WebAssembly.instance exports
 	__webpack_require__.w = {};

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	var startupResult = (function() {
 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 115);
 	})();

 	webpackJsonpCallback([[], {}, 0, [1]]);
 	return startupResult;
